import { UserlicenseService } from './../../services/userlicense.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { TechnicianService } from 'src/app/services/technician.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { DeleteBtnRenderer } from 'src/app/delete-action-btn-renderer.component';
import { EditBtnRenderer } from 'src/app/edit-action-btn-renderer.component';
import { LanguageService } from 'src/app/services/language-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';

@Component({
  selector: 'app-user-license',
  templateUrl: './user-license.component.html',
  styleUrls: ['./user-license.component.scss'],
})
export class UserLicenseComponent implements OnInit {
  @ViewChild('AddBatch') private AddBatch!: TemplateRef<any>;

  dataSource = new MatTableDataSource();
  spinnerText: string = '';
  WOStatus: any = '';
  WOType: any = '';
  FailMode: any = '';
  SpareParts: any = '';
  user: any;
  ImageUrl: any;
  operator: any;
  userList: any = [];
  breadcrumList!: any;
  permisson!: any;
  IsWrite: boolean = false;
  IsAccess!: any;
  HeaderData: any = { Group: '', Plant: '' };
  HeaderForm!: FormGroup;
  minDate: any;
  maxDate: any;
  GroupList: any = [];
  PlantList: any = [];
  AllTool: any = [];
  GroupTempList: any = [];
  PlantTempList: any = [];
  technicianList: any = [];
  dateFilter: any = { From: '', To: '' };
  frmDate: any;
  tDate: any;
  isEdit: boolean = false;
  opratorList: any;
  moduleId: any;
  pageId: any;
  moduleList: any = [];
  userLicenseForm: FormGroup;
  moduleTempList: any = [];
  headerID: any;
  GroupId: any;
  isExist: boolean = false;
  langObj: any = {};
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  frameworkComponents: any;
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;

  gridOptions: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  lang: any;
  languageDir = 'ltr';

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private cilMasterService: CILMasterService,
    private technicianService: TechnicianService,
    private enterpriseGroupService: EnterPriseGroupService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private userManagementService: UserManagementService,
    private managerExecutionService: ManagerExecutionService,
    private UserlicenseService: UserlicenseService,
    private languageService: LanguageService,
    public translater: TranslaterService,
    public translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.frameworkComponents = {
      editRenderer: EditBtnRenderer,
      deleteRenderer: DeleteBtnRenderer,
    };
    this.columnDefs = [
      {
        headerName: 'Edit',
        field: 'edit',
        cellRenderer: 'editRenderer',
        maxWidth: 90,
        cellRendererParams: {
          onClick: this.openForm.bind(this),
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Delete',
        field: 'delete',
        cellRenderer: 'deleteRenderer',
        maxWidth: 90,
        cellRendererParams: {
          onClick: this.deleteRow.bind(this),
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Group',
        field: 'Group',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Module',
        field: 'ModuleName',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'No of Licenses',
        field: 'NoOfLicenses',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
    ];
  }

  ngOnInit(): void {
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
    this.getGroups();
    this.HeaderForm = this.fb.group({
      group: ['-1', Validators.required],
    });
    this.userLicenseForm = this.fb.group({
      module: ['', Validators.required],
      noOfLicense: ['', Validators.required],
    });

    this.getUserList();
    this.GetBreadcrumList();
    this.GetMenuAccess();
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    this.managerExecutionService.getUserList().subscribe(
      (res: any) => {
        this.spinner.hide();
        this.userList = res.UserList;
        // this.getOperatorData();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.userManagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  getFilterData() {
    if (!this.HeaderData.Group || !this.HeaderData.Plant) return;
    else {
      this.minDate = this.dateFilter.From;
      this.maxDate = this.dateFilter.To;
    }
  }

  openForm(value: any) {
    if (this.HeaderForm.value.group == '-1') {
      this.toaster.warning('Warning', ' Select Group');
      return;
    }

    if (value === 'add') {
      this.isEdit = false;
    } else {
      this.isEdit = true;
      this.headerID = value.rowData.Id;
      this.userLicenseForm.controls.module.patchValue(value.rowData.ModuleId);
      this.userLicenseForm.controls.noOfLicense.patchValue(
        value.rowData.NoOfLicenses
      );
    }
    this.getAllModules();
    let dialogRef = this.dialog.open(this.AddBatch, {
      width: '55%',
      height: '60%',
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialog result', result);
      this.userLicenseForm.reset();
      this.isExist = false;
    });
  }

  getGroups() {
    const key = {
      UserId: '',
    };
    const id = {
      value: 0,
    };
    this.cilMasterService.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.dropDownList;
        this.GroupTempList = data.dropDownList;
        if (this.GroupTempList && this.GroupTempList.length) {
          this.HeaderForm.get('group')?.setValue(this.GroupList[0].id);
          this.filterData();
          // this.getPlants(this.HeaderData.Group)
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  onGroupKey(value: any) {
    this.GroupList = this.searchGroupKey(value.value);
  }

  searchGroupKey(value: string) {
    let filter = value;
    return this.GroupTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  onPlantKey(value: any) {
    this.PlantList = this.searchPlantKey(value.value);
  }

  searchPlantKey(value: string) {
    let filter = value;
    return this.PlantTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  // editRow(element: any) {
  //   this.headerID = element.rowData.Id;
  //   this.openForm('');
  // }

  deleteRow(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to Delete WO!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result: any) => {
      if (result.value) {
        const data = {
          TransTypeId: 3,
          Eg_Id: this.HeaderForm.value.group,
          ModuleId: this.userLicenseForm.value.Module,
          NoOfLicenses: this.userLicenseForm.value.NoOfLicense,
          CreatedBy: this.user.UserName,
          CreatedAt: new Date(),
          UpdatedBy: this.user.UserName,
          Id: element.rowData.Id,
          IsActive: 0,
        };
        this.spinner.show();
        this.UserlicenseService.saveuserLicesneFormData(data).subscribe(
          (res: any) => {
            this.spinner.hide();
            if (!res.HasError) {
              this.toaster.success(res.ErrorMessage, 'Success', {
                timeOut: 3000,
              });
              this.filterData();
            } else this.toaster.error(res.ErrorMessage, 'Error');
          },
          (err: any) => {
            this.spinner.hide();
            this.toaster.error(err.ErrorMessage, 'Error', { timeOut: 3000 });
          }
        );
      }
    });
  }

  onFilterChanged(event: any) {
    this.gridOptions.api.setQuickFilter(event.value);
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    this.gridColumnApi.autoSizeAllColumns();
  }

  autoSizeGrid(){
    this.gridApi.setRowData(this.rowData);
    this.gridColumnApi.autoSizeAllColumns();
  }

  getAllModules(): void {
    this.languageService.getAllModule().subscribe(
      (data: any) => {
        this.moduleList = data.moduleList;
        this.moduleTempList = data.moduleList;
      },
      (error: any) => {
        this.toaster.error('error', error.message, { timeOut: 3000 });
      }
    );
  }
  onModulekey(value: any) {
    this.moduleList = this.searchModuleKey(value.value);
  }
  searchModuleKey(value: string) {
    let filter = value;
    return this.moduleTempList.filter((grp: any) => {
      let lowerCase = grp.moduleName.toLocaleLowerCase();
      return grp.moduleName.includes(filter) || lowerCase.startsWith(filter);
    });
  }


  saveuserLicesneFormData(headerID: any) {
    this.isExist = false;
    if (this.rowData) {
      const group = this.rowData.find((value) => {
        if (this.userLicenseForm.value.module == value.ModuleId) {
          this.isExist = true;
        }
      });
      if (this.isExist && !this.isEdit) {
        this.toaster.warning('Warning', ' Module Already Exist');
        return;
      }
    }
    const data = {
      TransTypeId: this.isEdit ? 2 : 1,
      Eg_Id: this.HeaderForm.value.group,
      ModuleId: this.userLicenseForm.value.module,
      NoOfLicenses: this.userLicenseForm.value.noOfLicense,
      headerID: headerID,
      CreatedBy: this.user.UserName,
      UpdatedBy: this.user.UserName,
      Id: this.isEdit ? this.headerID : 0,
      IsActive: 1,
    };
    this.spinner.show();

    this.UserlicenseService.saveuserLicesneFormData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (!res.HasError) {
          this.toaster.success(res.message, 'Success', { timeOut: 3000 });
          this.filterData();
          this.dialog.closeAll();
        } else this.toaster.error(res.ErrorMessage, 'Error', { timeOut: 3000 });
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err.ErrorMessage, 'Error');
      }
    );
  }

  filterData() {
    const data = {
      Eg_Id: this.HeaderForm.value.group,
    };
    this.UserlicenseService.filterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.userlicensedata) {
          this.rowData = res.userlicensedata;
          this.autoSizeGrid();
          this.rowData.map((row: any) => {
            row.IsWrite = true;
          });
        }
        // if (!res.HasError) {
        //   this.toaster.success(res.ErrorMessage, 'Success', { timeOut: 3000 })
        // } else this.toaster.error(res.ErrorMessage, 'Error', { timeOut: 3000 })
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err.ErrorMessage, 'Error');
      }
    );
  }
}
